

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

import { MwcDestroyService } from 'mwc/core/services';
import { BooleanInput, MwcSafeAny } from 'mwc/core/types';
import { InputBoolean } from 'mwc/core/util';

import { MwcOptionGroupComponent } from './option-group.component';

@Component({
  selector: 'mwc-option',
  exportAs: 'mwcOption',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MwcDestroyService],
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class MwcOptionComponent implements OnChanges, OnInit {
  static ngAcceptInputType_mwcDisabled: BooleanInput;
  static ngAcceptInputType_mwcHide: BooleanInput;
  static ngAcceptInputType_mwcCustomContent: BooleanInput;

  changes = new Subject();
  groupLabel: string | number | TemplateRef<MwcSafeAny> | null = null;
  @ViewChild(TemplateRef, { static: true }) template!: TemplateRef<MwcSafeAny>;
  @Input() mwcLabel: string | number | null = null;
  @Input() mwcValue: MwcSafeAny | null = null;
  @Input() @InputBoolean() mwcDisabled = false;
  @Input() @InputBoolean() mwcHide = false;
  @Input() @InputBoolean() mwcCustomContent = false;

  constructor(@Optional() private mwcOptionGroupComponent: MwcOptionGroupComponent, private destroy$: MwcDestroyService) {}

  ngOnInit(): void {
    if (this.mwcOptionGroupComponent) {
      this.mwcOptionGroupComponent.changes.pipe(startWith(true), takeUntil(this.destroy$)).subscribe(() => {
        this.groupLabel = this.mwcOptionGroupComponent.mwcLabel;
      });
    }
  }

  ngOnChanges(): void {
    this.changes.next();
  }
}
